import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

/**
 * ValidTo Partial Date Cell
 * One of the most commonly used date variables, shown using the DateCellRenderer
 */
export const validToPartialTable: Columns<any> = {
  title: 'common.date.validto',
  key: 'validTo',
  cellRenderer: DateCellComponent,
}
